import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import axios from 'axios';

import Dashboard from './Dashboard';
import Upload from './Upload';
import ViewSpec from './ViewSpec';
import Contact from './Contact';
import Profile from './Profile';
import Login from './Login';

import Header from './components/Header';

axios.interceptors.response.use(null, function (error) {
  if (error.response.status === 403) {
    window.location.href = '/signin';
  }
  return Promise.reject(error);
});

export default class App extends Component {
  componentWillMount() {
    // check cookies here
    // if none redirect to login & remove cookie
  }

  render() {
    return (
      <Switch>
        <Route path="/login">
          <React.Fragment>
            <Header hideAuth />
            <div style={{ maxWidth: 550, margin: 'auto' }}>
              <Login />
            </div>
          </React.Fragment>
        </Route>
        <Route path="/">
          <React.Fragment>
            <Header />
            <div style={{ maxWidth: 1400, margin: 'auto' }}>
              <Switch>
                <Route exact path="/" component={Dashboard} />
                <Route path="/preview/:adId" component={Upload} />
                <Route path="/upload" component={Upload} />
                <Route path="/view-spec" component={ViewSpec} />
                <Route path="/contact" component={Contact} />
                <Route path="/profile" component={Profile} />
              </Switch>
            </div>
          </React.Fragment>
        </Route>
      </Switch>
    );
  }
}




// WEBPACK FOOTER //
// ./client/App.js